import { render, staticRenderFns } from "./Thinking.vue?vue&type=template&id=2fbea650&scoped=true"
import script from "./Thinking.vue?vue&type=script&lang=js"
export * from "./Thinking.vue?vue&type=script&lang=js"
import style0 from "./Thinking.vue?vue&type=style&index=0&id=2fbea650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbea650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VProgressCircular})
